import React, {Component, Fragment} from "react";
import styled from "styled-components";

const monthNames = ["January", "February", "March", "April", "May", "June",
"July", "August", "September", "October", "November", "December"
];

function numberFormat(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

class Production extends Component {
  constructor(props) {
    super(props);
    
    if(this.props.label !== undefined){
      this.state = this.props.label;
      this.state.allowdisp = true;
    } else {
      this.state = {allowdisp: false};
    }
    
    // this.state = {
    //     allowdisp: true,
    //     customername: "Budi Sugiono",
    //     customerphone: "08112345678",
    //     customeraddress: "Jl. Coklat no. 1",
    //     invoice_no: "INV-2310310014",
    //     mp_invoice: "",
    //     invoice_date: "2023-10-30 23:00:00",
    //     sales_channel: "WhatsApp",
    //     gross_total: 5000000,
    //     shipping_cost: 200000,
    //     discount: 0,
    //     grand_total: 1600000,
    //     items: [
    //       {
    //         qty: 2,
    //         name: "Produk A",
    //         price: 100000,
    //       },
    //       {
    //         qty: 3,
    //         name: "Produk B",
    //         price: 200000,
    //       },
    //       {
    //         qty: 1,
    //         name: "Produk C",
    //         price: 600000,
    //       },
    //     ],
    // }
    
    //disable this after layouting
    //this.state.allowdisp = true;
    
  }
  
  renderItems(){
    let disp = this.state.production_goods_details.map((dt) => {
      return (
        <TableRow>
          <TableCol className="tdept">{dt.dept}</TableCol>
          <TableCol className="tname">{dt.goods_name}{dt.notes.length > 0 ? (<><br/><Notes>{dt.notes}</Notes></>) : ""}</TableCol>
          <TableCol className="align-right tqty">{dt.quantity}</TableCol>
        </TableRow>
      )
    });
    
    return disp;
  }
  
  grandTotal(){
    let total = 0;
    this.state.spo_goods_details.forEach((dt) => {
      total += dt.price * dt.quantity;
    });
    
    return total;
  }
  
  convertDate(datestr){
    let date_start = new Date(datestr.substr(0, 10));
    
    let start_year = date_start.getFullYear();
    let start_month = date_start.getMonth();
    let start_date = date_start.getDate();
    
    let returnstr = start_date.toString().padStart(2, "0") + " " + monthNames[start_month] + " " + start_year;
    
    return returnstr;
  }
  
  render() {
    return (
      <OuterWrap>
      <Wrapper>
        {this.state.allowdisp &&
        <>
        <Header>
          <HeaderLeft>
            <HeaderLogo src="new_logo_monogram.png" />
          </HeaderLeft>
          <HeaderRight>
            <HeaderInvoiceWrap>
              <HeaderInvoice>PRODUCTION</HeaderInvoice>
              <HeaderInvoiceNo>{this.state.no_production}</HeaderInvoiceNo>
              <HeaderInvoiceNo>{this.state.spo.no_spo}</HeaderInvoiceNo>
              {/*this.state.mp_invoice.length > 0 &&
                <HeaderInvoiceMP>{this.state.mp_invoice}</HeaderInvoiceMP>
              */}
            </HeaderInvoiceWrap>
          </HeaderRight>
        </Header>
        <Recipient>
          <RecipientRow>
            <RecipientLeft>Delivery Date </RecipientLeft>
            <RecipientRight>{this.convertDate(this.state.due_date)} {this.state.packages.delivery_time}:00</RecipientRight>
          </RecipientRow>
          <RecipientRow>
            <RecipientLeft>Deliver to </RecipientLeft>
            <RecipientRight>{this.state.packages.name}</RecipientRight>
          </RecipientRow>
          <RecipientRow>
            <RecipientLeft>Sender </RecipientLeft>
            <RecipientRight>{this.state.packages.sender_name}</RecipientRight>
          </RecipientRow>
        </Recipient>
        <TableContents>
          <TableRow>
            <TableHeader>DEPARMENT</TableHeader>
            <TableHeader>ITEM DESCRIPTION</TableHeader>
            <TableHeader>QTY</TableHeader>
          </TableRow>
          <TableRow>
            <TableCol /><TableCol /><TableCol />
          </TableRow>
          {this.renderItems()}
        </TableContents>
        <Totals>
          {/*<TotalRow>
            <TotalLeft></TotalLeft>
            <TotalMid>Total</TotalMid>
            <TotalRight>IDR {numberFormat(this.state.gross_total)}</TotalRight>
          </TotalRow>
          <TotalRow>
            <TotalLeft></TotalLeft>
            <TotalMid>Shipping Cost {this.state.hasadditional ? "and Additionals" : ""}</TotalMid>
            <TotalRight>IDR {numberFormat(this.state.shipping_cost)}</TotalRight>
          </TotalRow>
          {this.state.discount > 0 &&
          <TotalRow>
            <TotalLeft></TotalLeft>
            <TotalMid>Discount</TotalMid>
            <TotalRight>IDR {numberFormat(this.state.discount)}</TotalRight>
          </TotalRow>
          }*/}
          {/*<TotalRow className="grandtotalrow">
            <TotalLeft></TotalLeft>
            <TotalMid className="grandtotalcol">GRAND TOTAL</TotalMid>
            <TotalRight className="grandtotalcol">IDR {numberFormat(this.grandTotal())}</TotalRight>
          </TotalRow>*/}
        </Totals>
        </>
        }
      </Wrapper>
      </OuterWrap>
    );
  }
}

const OuterWrap = styled.div`
  
`;

const Wrapper = styled.div`
  display:block;
  position:relative;
  /*width: 14cm;*/
  width: 12.5cm;
  height: 17cm;
  margin-top: 1cm;
  margin-left: 0.5cm;
  border: 2px solid black;
  
  padding:5mm;
  
  font-family: Helvetica, Arial, sans-serif;
  font-size: 11px;
  line-height: 1em;
  
  /*
  @page {
    size: landscape;
  }*/
`;

const Header = styled.div`
  display:block;
  position:relative;
  width: 100%;
  border-bottom: 1px solid black;
  
  /*CLEARFIX*/
  overflow: auto;
  &:after {
      content: "";
      clear:both;
      display:table;
  }
`;

const HeaderLeft = styled.div`
  display:block;
  position:relative;
  width: 30%;
  float:left;
  
`;

const HeaderLogo = styled.img`
  display:block;
  position:relative;
  width: 90%;
  margin:auto;
  margin-bottom: 1mm;
`;

const HeaderRight = styled.div`
  display:block;
  position:relative;
  width: 65%;
  height:20mm;
  float:left;
`;

const HeaderInvoiceWrap = styled.div`
  display:block;
  position:absolute;
  width: 100%;
  bottom: 0;
`;

const HeaderText = styled.p`
  text-align:center;
  margin-bottom: 1mm;
`;

const HeaderInvoice = styled.h1`
  text-align:right;
  margin-bottom: 4mm;
  font-size: 2.5em;
`;

const HeaderInvoiceNo = styled.div`
  font-size:1.2em;
  text-align:right;
  margin-bottom: 1mm;
`;

const HeaderInvoiceMP = styled.div`
  font-size:1em;
  text-align:right;
  margin-bottom: 1mm;
`;

const Recipient = styled.div`
  display:block;
  position:relative;
  width: 100%;
  padding-top:3mm;
  padding-bottom: 5mm;
`;

const RecipientRow = styled.div`
  display:block;
  position:relative;
  width: 100%;
  padding-bottom:1mm;
  
  /*CLEARFIX*/
  overflow: auto;
  &:after {
      content: "";
      clear:both;
      display:table;
  }
`;

const RecipientLeft = styled.div`
  display:block;
  position:relative;
  width: 18%;
  float:left;
  
  &:after {
    position: absolute;
    content: ":";
    right:0;
  }
`;

const RecipientRightLarge = styled.div`
  display:block;
  position:relative;
  width: 75%;
  padding-left:5%;
  float:left;
  font-size:1.3em;
  font-weight:bold;
`;

const RecipientRight = styled.div`
  display:block;
  position:relative;
  width: 75%;
  padding-left:5%;
  float:left;
`;

const TextRow = styled.div`
  display:block;
  position:relative;
  width: 100%;
  font-weight: bold;
`;

const Totals = styled.div`
  display:block;
  position:relative;
  width: 100%;
  padding-top:8mm;
`;

const TotalRow = styled .div`
  display:block;
  position:relative;
  width: 100%;
  padding-bottom: 2mm;
  
  &.grandtotalrow {
    padding-top:5mm; 
  }
  
  /*CLEARFIX*/
  overflow: auto;
  &:after {
      content: "";
      clear:both;
      display:table;
  }
`;

const TotalLeft = styled.div`
  display:block;
  position:relative;
  width: 50%;
  float:left;
  height: 1mm;
`;

const TotalMid = styled.div`
  display:block;
  position:relative;
  width: 25%;
  float:left;
  
  &.grandtotalcol {
    font-size: 1.2em;
    font-weight:bold;
  }
`;


const TotalRight = styled.div`
  text-align: right;
  display:block;
  position:relative;
  width: 24%;
  padding-right:1%;
  float:left;
  
  &.grandtotalcol {
    font-size: 1.2em;
    font-weight:bold;
  }
`;

const PaidRow = styled .div`
  display:block;
  position:relative;
  width: 100%;
  margin-top:5mm;
  padding-bottom: 2mm;
  
  /*CLEARFIX*/
  overflow: auto;
  &:after {
      content: "";
      clear:both;
      display:table;
  }
`;

const PaidText = styled.div`
  text-align: right;
  display:block;
  position:relative;
  padding-right:1%;
  height: 4.5cm;
  line-height: 1cm;
  
  color: red;
  font-size:36px;
`;
  
const TableContents = styled.table`
  display:table;
  position:relative;
  width: 100%;
  border-spacing: 0;
  margin-top: 1mm;
  font-size:11px;
`;

const TableRow = styled.tr`
  display:table-row;
  position:relative;
  width: 100%;
`;

const TableHeader = styled.th`
  display:table-cell;
  position:relative;
  background: black;
  color: white;
  margin-bottom: 2mm;
  font-size: 1.2em;
  padding: 1%;
`;

const TableCol = styled.td`
  display: table-cell;
  position:relative;
  padding: 1%;
  vertical-align:top;
  font-size: 1em;
  
  &.align-right {
    text-align: right;
  }
  &.tdept {
    width: 25%; 
  }
  &.tname {
    width: 55%; 
  }
  &.tqty {
    width: 20%; 
    text-align: center;
  }
  &.tprice {
    width: 25%; 
  }
  &.ttotal {
    width: 25%; 
  }
`;

const Notes = styled.span`
  display: inline-block;
  font-size: 0.75em;
`;

const TableBoldText = styled.div`
  font-weight:bold;
  padding: 0;
  margin: 0;
  font-size: 0.9em !important;
`;

const TableRegularText = styled.div`
  padding: 0;
  margin: 2mm 1mm;
  font-size: 0.9em !important;
`;

const BoldText = styled.div`
  font-weight:bold;
  padding: 0;
  margin: 0;
  margin-bottom: 1mm;
  
  &.shippingaddress {
    margin-bottom: 3mm; 
    text-align: center;
  }
`;

const RegularText = styled.div`
  padding: 0;
  margin: 0;
  margin-bottom: 1mm;
`;

const Shipping = styled.div`
  display:block;
  position:relative;
  width: 48%;
  float:left;
  padding-bottom:2cm;
  border-bottom: 1px solid black;
`;

const Footer = styled.div`
  display:block;
  position:absolute;
  bottom: 0;
  width: 97%;
  padding-bottom:2mm;
`;

const FooterRow = styled.div`
  display:block;
  position:relative;
  width: 100%;
  
  padding-top:2mm;
  
  /*CLEARFIX*/
  overflow: auto;
  &:after {
      content: "";
      clear:both;
      display:table;
  }
`;

const FooterLeft = styled.div`
  display:block;
  position:relative;
  width: 33%;
  float:left;
  
  text-align:center;
`;

const FooterMid = styled.div`
  display:block;
  position:relative;
  width: 33%;
  float:left;
  
  text-align:center;
`;

const FooterRight = styled.div`
  display:block;
  position:relative;
  width: 33%;
  float:left;
  
  text-align:center;
`;

export default Production;